/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AccountsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create a self-serve account from the public website
   *
   * Public endpoint that allows account creation from the public website.
   *
   * This endpoint:
   * - Accepts company and owner information
   * - Determines the appropriate Hire region based on country (US, EU, or APAC)
   * - Forwards the request to Hire which creates the account with inferred defaults
   *
   * **Region Routing (WX determines which Hire server to hit):**
   * - India (IN) → APAC region (ap-1.fountain.com)
   * - EU/EEA countries → EU region (eu-1.fountain.com)
   * - All other countries → US region (us-3.fountain.com)
   *
   * **Hire infers the following from country_code:**
   * - WX domain
   * - SMS provider (Exotel for India, Bird for others)
   * - Default timezone
   * - Account is marked as self-serve for tracking
   *
   * @param requestBody
   * @returns any Account successfully created
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesAccountsCreate(
    requestBody: {
      /**
       * Name of the company
       */
      company_name: string;
      /**
       * Full name of the account owner
       */
      owner_name: string;
      /**
       * Email address of the account owner
       */
      owner_email: string;
      /**
       * ISO 3166-1 alpha-2 country code
       */
      country: string;
      /**
       * Company domain
       */
      company_domain?: string;
      /**
       * Industry type
       */
      industry?: string;
      /**
       * Custom industry if not in standard list
       */
      custom_industry?: string;
      /**
       * Estimated number of hires per year
       */
      hires_per_year?: string;
      /**
       * Desired outcomes
       */
      outcomes?: Array<string>;
      /**
       * Inferred products
       */
      inferred_products?: Array<'fountain_hire' | 'hire_go' | 'ai_recruiter' | 'referrals' | 'pool' | 'source' | 'onboard' | 'i9_center' | 'compliance' | 'shift'>;
      /**
       * Branding information
       */
      branding?: {
        /**
         * URL of the company logo
         */
        logo_url?: string;
        /**
         * Primary brand color
         */
        primary_color?: string;
        /**
         * Secondary brand color
         */
        secondary_color?: string;
        /**
         * Company name
         */
        company_name?: string;
        /**
         * Company domain
         */
        company_domain?: string;
      };
      /**
       * Salesforce account ID
       */
      salesforce_id?: string;
      /**
       * Hire domain override (e.g., us-3.fountain.com)
       */
      hire_domain?: string;
      /**
       * UUID of the Hire parent account to attach the new account to
       */
      hire_parent_account_uuid?: string;
      /**
       * Company time zone (IANA format)
       */
      time_zone?: string;
      /**
       * Account type
       */
      account_type?: 'active' | 'internal' | 'pilot' | 'demo';
      /**
       * SMS provider
       */
      sms_provider?: 'bird' | 'twilio' | 'exotel';
      /**
       * Skip polling for user creation and registration URL
       */
      skip_polling?: boolean;
      /**
       * Whether this is a self-serve account (defaults to true)
       */
      self_serve?: boolean;
    },
  ): CancelablePromise<{
    data?: {
      success?: boolean;
      account?: {
        /**
         * Hire account ID
         */
        id?: string;
        /**
         * External account ID
         */
        external_id?: string;
        /**
         * Account name
         */
        name?: string;
        /**
         * Account slug
         */
        slug?: string;
      };
      company?: {
        /**
         * WX company UUID
         */
        uuid?: string;
        /**
         * Company name
         */
        name?: string;
      };
      /**
       * The Hire region where the account was created
       */
      region?: 'us' | 'eu' | 'apac' | 'custom';
      /**
       * URL for the user to complete registration (null if polling was skipped or user not found)
       */
      registerUrl?: string | null;
      /**
       * Human-readable status message
       */
      message?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/accounts/create',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid input`,
        500: `default error response`,
      },
    });
  }

  /**
   * Create an account via internal tooling
   *
   * Internal endpoint for account creation used by Fountain employees.
   *
   * This endpoint:
   * - Requires VPN access and Cloudflare Turnstile validation
   * - Accepts company and owner information
   * - Determines the appropriate Hire region based on country (US, EU, or APAC)
   * - Forwards the request to Hire with self_serve: false
   *
   * **Region Routing (WX determines which Hire server to hit):**
   * - India (IN) → APAC region (ap-1.fountain.com)
   * - EU/EEA countries → EU region (eu-1.fountain.com)
   * - All other countries → US region (us-3.fountain.com)
   *
   * **Hire infers the following from country_code:**
   * - WX domain
   * - SMS provider (Exotel for India, Bird for others)
   * - Default timezone
   *
   * @param requestBody
   * @returns any Account successfully created
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesAccountsInternalCreate(
    requestBody: {
      /**
       * Name of the company
       */
      company_name: string;
      /**
       * Full name of the account owner
       */
      owner_name: string;
      /**
       * Email address of the account owner
       */
      owner_email: string;
      /**
       * ISO 3166-1 alpha-2 country code
       */
      country: string;
      /**
       * Company domain
       */
      company_domain?: string;
      /**
       * Industry type
       */
      industry?: string;
      /**
       * Custom industry if not in standard list
       */
      custom_industry?: string;
      /**
       * Estimated number of hires per year
       */
      hires_per_year?: string;
      /**
       * Desired outcomes
       */
      outcomes?: Array<string>;
      /**
       * Inferred products
       */
      inferred_products?: Array<'fountain_hire' | 'hire_go' | 'ai_recruiter' | 'referrals' | 'pool' | 'source' | 'onboard' | 'i9_center' | 'compliance' | 'shift'>;
      /**
       * Branding information
       */
      branding?: {
        /**
         * URL of the company logo
         */
        logo_url?: string;
        /**
         * Primary brand color
         */
        primary_color?: string;
        /**
         * Secondary brand color
         */
        secondary_color?: string;
        /**
         * Company name
         */
        company_name?: string;
        /**
         * Company domain
         */
        company_domain?: string;
      };
      /**
       * Salesforce account ID
       */
      salesforce_id?: string;
      /**
       * Hire domain override (e.g., us-3.fountain.com)
       */
      hire_domain?: string;
      /**
       * UUID of the Hire parent account to attach the new account to
       */
      hire_parent_account_uuid?: string;
      /**
       * Company time zone (IANA format)
       */
      time_zone?: string;
      /**
       * Account type
       */
      account_type?: 'active' | 'internal' | 'pilot' | 'demo';
      /**
       * SMS provider
       */
      sms_provider?: 'bird' | 'twilio' | 'exotel';
      /**
       * Skip polling for user creation and registration URL
       */
      skip_polling?: boolean;
      /**
       * Whether this is a self-serve account (defaults to true)
       */
      self_serve?: boolean;
    },
  ): CancelablePromise<{
    data?: {
      success?: boolean;
      account?: {
        /**
         * Hire account ID
         */
        id?: string;
        /**
         * External account ID
         */
        external_id?: string;
        /**
         * Account name
         */
        name?: string;
        /**
         * Account slug
         */
        slug?: string;
      };
      company?: {
        /**
         * WX company UUID
         */
        uuid?: string;
        /**
         * Company name
         */
        name?: string;
      };
      /**
       * The Hire region where the account was created
       */
      region?: 'us' | 'eu' | 'apac' | 'custom';
      /**
       * URL for the user to complete registration (null if polling was skipped or user not found)
       */
      registerUrl?: string | null;
      /**
       * Human-readable status message
       */
      message?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/accounts/internal/create',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid input`,
        500: `default error response`,
      },
    });
  }

}
